/* eslint-disable */

import {config} from '@shared/_services/config';
import {authHeader, handleResponse} from '@shared/_helpers';
import {constants} from '@shared/_services/constants'
import UserRoleApi from '@shared/_api/userRole';
import {ADD_ROLE_SUCCESS, DELETE_ROLE_SUCCESS, FETCH_ALL_ROLES_SUCCESS, UPDATE_ROLE_SUCCESS} from "./mutationTypes";

const state = {
    rolesLoaded: true,
    roles: [],
};

const getters = {
    roleFields: (state, getters, rootState, rootGetters) => {
        let roleFields = [{key: 'name', alias: 'Name', sortable: true}];
        if (state.roles && state.roles.length > 0 && state.roles[0].permissions) { // TODO
            if (rootGetters['resourcesManagement/resourceNames'].length > 0) {
                rootGetters['resourcesManagement/resourceNames'].forEach((el) => {
                    roleFields.push({
                        key: el,
                        sortable: true
                    }) // TODO mutations
                })
            }
            // TODO check
        }
        roleFields.push({
            key: 'Actions',
            class: 'align-middle table-action-column'
        });
        return roleFields
    },
    rolesArray: (state, getters, rootState, rootGetters) => {
        let rolesArray = [];
        if (state.roles && state.roles.length > 0) { // TODO check
            state.roles.forEach(el => {
                let tmp = {};
                tmp.name = el.name;
                tmp.id = el.id;
                // let tmpPerm = tmp.permissions.filter((x, i, self) => getters.resourceNames.includes(x.resource.name))
                // default
                if (rootGetters['resourcesManagement/resourceNames'].length > 0) { // tODO
                    rootGetters['resourcesManagement/resourceNames'].forEach(resource => {
                        tmp[resource] = constants.defaultAccessRight
                    });
                    el.permissions.forEach(el => {
                        tmp[el.resource.name] = el.operation
                    })
                }
                rolesArray.push(tmp)
            })
        }
        return rolesArray
    },
    roleNames: state => {
        if (state.roles) { // TODO check
            return state.roles.map(role => role.name)
        }
        return []
    },
    // resourceNames: state => {
    //   if (state.roles && state.roles.length > 0 && state.roles[0].permissions) {
    //     // permissionsArr - array of array of objects
    //     const permissionsArr =  state.roles.map(role => role.permissions)
    //     // 1) flatten permissionsArr --> array of resources  (concat.apply)
    //     // 2) get resources' names --> array of resources'names (map)
    //     // 3) get unique names (filter)
    //     return [].concat.apply([], permissionsArr).map(el => el.resource.name).filter((x, i, a) => a.indexOf(x) == i)
    //   }
    //   return []
    // },
    roleById: (state) => (id) => {
        if (state.roles && state.roles.length > 0) {
            let role = JSON.parse(JSON.stringify(state.roles.find(el => {
                return el.id === id
            })));
            if (role) {
                // TODO
                return role
            }
            return null
        }
        return null
    }
};

const actions = {
    fetchRoles({commit}) {
        return UserRoleApi.fetchAll().then(roles => commit(FETCH_ALL_ROLES_SUCCESS, roles))
            .catch(error => {
                console.log(error)
            })

    },
    deleteRoleById({commit}, {role}) {
        UserRoleApi.delete(role.id).then(() => commit(DELETE_ROLE_SUCCESS, role.id))
            .catch(error => {
                console.log(error)
            });
    },
    updateRoleById({commit}, {role}) {
        UserRoleApi.update(role).then(role => commit(UPDATE_ROLE_SUCCESS, role))
            .catch(error => {
                console.log(error)
            });
    },
    addRoleViaAdmin({commit, dispatch}, {role}) {
        UserRoleApi.add(role).then(role => commit(ADD_ROLE_SUCCESS, role))
            .catch(error => {
                console.log(error)
            });
    }
};

const mutations = {
    [DELETE_ROLE_SUCCESS](state, id) {
        const idx = state.roles.findIndex(x => x.id === id);
        if (idx === -1) {
            // TODO
        } else {
            state.roles.splice(idx, 1)
        }
    },
    [UPDATE_ROLE_SUCCESS](state, role) {
        const idx = state.roles.findIndex(x => x.id === role.id);
        if (idx === -1) {
            // TODO
        } else {
            state.roles.splice(idx, 1, role)
        }
    },
    [FETCH_ALL_ROLES_SUCCESS](state, roles) {
        state.roles = roles;
        state.rolesLoaded = true
    },
    [ADD_ROLE_SUCCESS](state) {
        // TODO
    }
};

export const rolesManagement = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};